// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/font.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import httpRequest from '@/utils/httpRequest'
import api from '@/utils/api'
import animated from 'animate.css'

Vue.use(animated)
Vue.config.productionTip = false
Vue.use(ElementUI);

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$api = api // ajax请求方法

// 是否为手机端
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)
// 移动端引入公共样式
if (flag) {
  require('@/assets/css/mobile.scss');
}else{
  require('@/assets/css/pc.css');
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js